// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"Pagination_paginationWrapper__VoB1c","paginationButton":"Pagination_paginationButton__JWP1I","pageSelect":"Pagination_pageSelect__uHDY9"};